
import { isEmpty } from "@gsd/backoffice-ui";
import { actions } from "@gsd/redux-store-backoffice";
import React from "react";
import DashbardCardList from "../component/Dashboard/DashboardCardList";

import { connect } from "react-redux";
import { Link } from "react-router-dom";
import type { Dispatch } from "redux";
import type { MenuType } from "../constants/apps";
import { IDM_MENU } from "../constants/apps";

const {
  account: {
    creators: { getDashboardIdm }
  }
} = actions;

const mapStateToProps = (state: any) => ({
  ...state.account
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    getDashboard: () => dispatch(getDashboardIdm())
  };
};

type State = {
	isLoggedOut: boolean,
	dashboardSections: Array<unknown>
};
type DashboardSectionContainerProps = ReturnType<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

class DashboardSectionContainer extends React.Component<DashboardSectionContainerProps> {
  state: State;
  constructor(props: DashboardSectionContainerProps) {
    super(props);
    this.state = {
      isLoggedOut:false,
      dashboardSections: []
    };
  }

  async componentDidMount() {
    await this.props.getDashboard();
  }

  render() {
    const { dashboard, isLoading, token } = this.props;
    const dashboardSections = dashboard
      .filter((das: any) => das.key !== "logout")
      .map((das: any) => {
        const menu = IDM_MENU.filter((mi: MenuType) => {
          return mi.key === das.key;
        }
        );
        const { route, img , description } = (menu[0]) || {};
        const { key, label } = das;
        return { label, key, route, img, description };
      });
    return (
      <React.Fragment>

        { isEmpty(dashboardSections) ? (
          token === "" ? null : (
            <div className="alert alert-primary" role="alert">
              <h4 className="alert-heading">Permesso negato!</h4>
              <p>Non hai i permessi per accedere a questa pagina!</p>
              <p></p>
              <hr/>
              <p className="mb-0">
                <Link to='/logout'>
                  <div className="btn">
											Logout
                  </div>
                </Link>
              </p>
            </div>
          )
        ) : (
          <DashbardCardList
            cards={dashboardSections}
            isLoading={isLoading}
          />
        ) }

      </React.Fragment>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DashboardSectionContainer);
